import ScoreTable from "./ScoreTable";
export default ScoreTable;